import type { I18nKey } from '../../i18n/index.ts';

/**
 * The gateway's quality excerpt `quality:23%:5/22:120m` (probe quality
 * signal, #2658 follow-up) as 「近 120 分钟 23% 探针失败/超慢（5/22 发）」;
 * null for any other excerpt.
 */
export function qualityEvidence(
  excerpt: string | null,
  t: (key: I18nKey, params: Readonly<Record<string, string>>) => string,
): string | null {
  const match = /^quality:(\d+)%:(\d+)\/(\d+):(\d+)m$/.exec(excerpt ?? '');
  if (match === null) return null;
  return t('guaranteed.leg.quality_detail', {
    pct: match[1] ?? '',
    bad: match[2] ?? '',
    total: match[3] ?? '',
    minutes: match[4] ?? '',
  });
}
